import { render, staticRenderFns } from "./SeriesHistoryShow.vue?vue&type=template&id=c009b736&scoped=true"
import script from "./SeriesHistoryShow.vue?vue&type=script&lang=js"
export * from "./SeriesHistoryShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c009b736",
  null
  
)

export default component.exports